import React from 'react';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const PaperComponent = React.memo((props) => {
    const nodeRef = React.useRef(null);
    return (
        <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title">
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
});

export default PaperComponent;